/*
 * Copyright 2020 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
  },
  path: {
    fill: '#7df3e1',
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      transform="translate(-15,0)"
      viewBox="0 0 202 100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M142.155 73.188C134.642 72.6184 125.402 71.3747 115.531 69.5386L96.7573 100H126.936L142.388 73.2244L142.155 73.188Z"
          fill="#FFFFFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M170.328 63.5384C177.532 64.5452 189.518 66.0077 197.408 65.7662L188.575 0H158.401L122.299 58.5586C130.72 60.4904 139.454 62.0987 148.088 63.347L167.041 30.5299L170.328 63.5384Z"
          fill="#FFFFFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M197.482 66.3447C190.893 68.1307 178.54 70.0078 171.033 70.6502L173.952 100H202L197.482 66.3447Z"
          fill="#FFFFFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M136.612 9.59923C132.317 9.21653 126.091 8.83838 121.518 8.83838C99.219 8.83838 63.6479 13.0481 63.6479 26.493C63.6479 48.699 139.855 66.3262 185.639 66.3262C188.132 66.3262 194.76 66.1258 197.382 65.7476C167.874 63.5197 99.9241 46.5987 99.9241 26.5294C99.9241 15.8228 119.219 11.2667 136.612 9.59923Z"
          fill="#FFFFFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M72.0204 9.59915C67.7255 9.21644 61.8963 8.6925 57.3283 8.6925C32.4377 8.6925 0 15.2805 0 29.9236C0 56.5809 73.073 74.1307 125.545 74.1307C128.033 74.1307 139.532 73.5657 142.154 73.1876C107.283 70.5542 35.3225 53.4964 35.3225 28.9349C35.3225 16.2282 52.4624 11.4717 72.0204 9.59915Z"
          fill="#FFFFFE"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="202" height="100" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LogoIcon;
